<template>
    <c-dialog ref="dialog" height="550" width="600" @resolve="editHandle">
        <c-form ref="form" unit-width="100%">
            <c-input type="hidden" name="id"></c-input>
            <c-form-item label="分类" required tip="请选择报价单关联分类">
                <c-select name="quotation_type_id" async @search="searchQuotationType"
                          :value-data="selectedQuotationType"></c-select>
            </c-form-item>
            <c-form-item label="标题" required tip="同一分类下标题名称不允许重复">
                <c-input name="title" maxlength="20"></c-input>
            </c-form-item>
            <c-form-item label="报价单图片" required>
                <c-upload-file filePath="quote" name="quotation_image" type="image" button="请选择图片" media></c-upload-file>
            </c-form-item>
            <c-form-item label="报价LOGO">
                <c-upload-file filePath="quote" name="quotation_logo" type="image" button="请选择图片" media></c-upload-file>
            </c-form-item>
            <c-form-item label="备注">
                <c-input type="textarea" name="remark"></c-input>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>
import {mapState} from 'vuex'

export default {
    computed: {},

    data() {
        return {
            editState: false,
            selectedQuotationType: []
        }
    },

    methods: {
        /*******搜索报价分类*****************/
        searchQuotationType(keyword, resolve) {
            this.request({
                url: '/quotation/type/options',
                data: {
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },

        /*********打开编辑框，初始化**********/
        open(data) {
            this.editState = !!data;
            this.$refs.form.clear();
            if (data) {
                //已选中的[分类]
                this.selectedQuotationType =[{
                    name: data.type_name,
                    value: data.quotation_type_id
                }];
                this.$refs.form.set(data);
            } else {
                this.$refs.form.set({
                });
            }
            //填充form表单
            this.$refs.dialog.open({
                title: data ? '编辑报价单' : '添加报价单'
            });
        },

        /*******添加、编辑提交处理方法********/
        editHandle(stop, next) {
            stop();
            this.$refs.form.submit({
                url: this.editState ? '/quotation/info/edit' : '/quotation/info/add',
                rule: {
                    quotation_type_id: '请选择报价分类',
                    title: '请选报价单标题',
                    quotation_image: '请上传报价单图片'
                },
                dataFormatter: data => {
                    return data;
                },
                success: (data, res) => {
                    next();
                    if (this.editState) {
                        this.$message({
                            message: '编辑成功',  // 提示内容,
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            message: '添加成功',  // 提示内容,
                            type: 'success'
                        });
                    }
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>